<template>
    <div>
        <BaseEchart :option="option" :height="height" :width="width"></BaseEchart>
    </div>
</template>


<script>
import BaseEchart from '@/components/base-echart/base-echart.vue';

export default {
    components: {
        BaseEchart,
    },
    props: {
        xData: {
            type: Array,
        },
        values: {
            type: Array,
        },
        height: {
            type: String,
            default: '380px',
        },
        width: {
            type: String,
            default: '200',
        },
    },
    computed: {
        option() {
            return {
                title: {
                    text: ''
                },
                legend: {
                    data: this.values.map(item => item.name),
                },
                radar: {
                    // shape: 'circle',
                    // indicator: [
                    //     { name: '数学', max: 150 },
                    //     { name: '语文', max: 150 },
                    //     { name: '英语', max: 150 },
                    //     { name: '生物', max: 100 },
                    //     { name: '政治', max: 100 },
                    //     { name: '历史', max: 100 }
                    // ]
                    indicator: this.xData,
                    //指示器文字换行 start
                    name: {
                        textStyle: {
                            color: 'black',
                            padding: [-10, -12],
                            // 居中
                            align: 'center',
                        },
                        formatter: function (text) {
                            var strlength = text.length;
                            if (strlength % 3 != 0) {
                                text = text.replace(/\S{3}/g, function (match) {
                                    return match + '\n'
                                })
                            } else {
                                text = text.replace(/\S{3}/g, function (match) {
                                    return match + '\n'
                                });
                                strlength = text.length;
                                text = text.substring(0, strlength - 1);
                            }
                            return text
                        }
                    }

                },
                // series: this.values
                series: [
                    {
                        name: '测评结果',
                        type: 'radar',
                        data: this.values
                        // data: [
                        //     {
                        //         value: [101, 60, 20, 99, 80, 78],
                        //         name: '小红'
                        //     },
                        //     {
                        //         value: [120, 140, 130, 66, 77, 88],
                        //         name: '小明'
                        //     }
                        // ]
                    }
                ]
            };
        }
    }
}
</script>